import script from "./ImportRecordingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportRecordingModal.vue?vue&type=script&setup=true&lang=js"

import "./ImportRecordingModal.vue?vue&type=style&index=0&id=60a232fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a232fe"]])

export default __exports__